<template>
  <tm-skeleton-table-body
    v-if="bodyOnly"
    :rows="rows"
    :columns="columns"
  />

  <tm-table-container v-else>
    <tm-table-semantic-skeleton
      :service-id="serviceId"
      :rows="rows"
      :columns="columns"
      :header-columns="headerColumns"
      :hide-gradient="hideGradient"
      :hide-checkboxes="hideCheckboxes"
      :has-actions="hasActions"
    />
  </tm-table-container>
</template>

<script setup lang="ts">
import { useTableSkeleton } from '@/composition/table/useTableSkeleton'
import TmSkeletonTableBody from '@/components/shared/skeletons/TmSkeletonTableBody.vue'
import type { TmTableSkeletonProps } from '@/components/shared/tables/tableBase'
import TmTableContainer from '@/components/shared/tables/TmTableContainer.vue'
import TmTableSemanticSkeleton from '@/components/shared/skeletons/TmTableSemanticSkeleton.vue'

const props = withDefaults(defineProps<TmTableSkeletonProps>(), {
  hasActions: true,
})

const { headerColumns, columns, rows } = useTableSkeleton(props.serviceId, {
  hideCheckboxes: props.hideCheckboxes,
  hasActions: props.hasActions,
  rowsToDisplay: props.rowsToDisplay,
})
</script>
